/** Path constants — never hardcode a route string. */
export const ROUTES = {
  login: '/login',
  register: '/register',

  stores: '/stores',
  storesNew: '/stores/new',
  storesJoin: '/stores/join',

  adminOwners: '/admin/owners',

  notFound: '/404',
} as const;

/** §1: владельческий раздел, всё под `/s/:storeId/...`. */
export function ownerPath(storeId: string, suffix = ''): string {
  return `/s/${storeId}${suffix}`;
}

/** §9: кабинет клиента, всё под `/c/:storeId/...`. */
export function clientPath(storeId: string, suffix = ''): string {
  return `/c/${storeId}${suffix}`;
}
